import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import ProductCartItem from "../../components/ProductCartItem/ProductCartItem.js";
import { Utils } from '../../Utils';

import './MyOrders.css';

class MyOrders extends React.Component {

  fakeProducts = [
    {
      id: 1,
      product: 'EASY',
      price_original: '24 999 Ft',
      price: '7 999 Ft',
      sale: 1,
      size: '37',
      color: 'multicolor',
      quantity: 1,
      image: 'assets/images/demo/shopping_cart_product.png',
    },
    {
      id: 2,
      product: 'EASY',
      price_original: '19 999 Ft',
      price: '19 999 Ft',
      sale: 0,
      size: '42',
      color: 'szürke',
      quantity: 1,
      image: 'assets/images/demo/shopping_cart_product.png',
    }
  ];
  
  constructor(props) {
      super(props);

      this.state = {
        order_id: 0,
        orders: [],
        hiding: false,
        show: false, 
      }
  }

  show() {
    const { order_id } = this.state;

    if (order_id === 0)
    {
      Utils.get_server_data(
        '',
        {
          ajax_event:'orders',
          APICACHE:'false'
        }, 
        {
          ajax_event: 'orders',
          formData: JSON.stringify({}),
        }
      )
      .then((res)=>{
        this.setState({orders: res.orders, show: true});
      });
    }
    else {
      this.setState({show: true});
    }
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  setOrderId(order_id) {
    this.setState({order_id: order_id, show: true},()=>{this.show()});
  }

  handle_submit(e, selected_order) {
    Utils.get_server_data(
      '',
      {
        ajax_event:'reorder',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'reorder',
        formData: JSON.stringify({order_id: selected_order.id}),
      }
    )
    .then((res)=>{

      window.AppRef.current.set_dialog_message(i18n.t('myOrdersAddedToCart'), {
        cancel: false,
        callback: () => 
        {
          window.AppRef.current.get_update_shopping_cart();
        }
      });
    });
  }

  render() {
    const {show, order_id, orders, hiding} = this.state;

    if (!show) return '';

    let selected_order = {};
    let class_name = 'msg1'; 

    if (!!order_id)
    {
      
      Object.keys(window.modals.MyOrdersRef.current.state.orders).map((key,index)=>{
          const item = window.modals.MyOrdersRef.current.state.orders[key];

          if(item.id===order_id){
            selected_order = item;
          }
      })
      
      class_name = 'msg2';
    }

    const reorder_disabled = !selected_order.products || !selected_order.products.filter(_ => !parseInt(_.missing_id)).length;

    return <div
    className={`container page_my_orders ${hiding ? 'out' : ''} ${class_name}`}>
      <div className="content">
      
        <PageHeader parent_ref={this} no_close title={i18n.t('myOrdersTitle')} />

        <div className='container_inner'>
          {parseInt(order_id) === 0 && !Object.keys(orders).length ? <div className='emplty_list_message'>{i18n.t('myOrdersEmpty')}</div> : ''}
          {parseInt(order_id) === 0 ? <> 
            {Object.keys(orders).map((key,index) => {
              const order = orders[key];
              return order.products.length ? <div key={order.id} className="list_item_badge" onClick={() => {window.modals.MyOrdersRef_2.current.setOrderId(order.id)}}>
              <div className="left">
                <label>{i18n.t('myOrdersItemTitle', { order_code: order.order_code })}</label>
                <div className="date">{order.date} {parseInt(order.status_int) == 3 ? ' ('+i18n.t('myOrdersDeletedOrder')+')': ''}</div>
              </div>
              <ReactSVG className="right" src="assets/images/arrow_down.svg" /> 
            </div> : '';
            })}
          </>
          : <>
              {!!selected_order.products && !!selected_order.products.length ? Object.keys(selected_order.products).map((key,index) =>{const product = selected_order.products[key]; return <ProductCartItem key={product.id} product={product} />}) : ''}
              {reorder_disabled ? '' : <button type="button" className="button" onClick={(e) => this.handle_submit(e, selected_order)}>{i18n.t('myOrdersResend')}</button>}
            </>
          }
        </div>

      </div>
    </div>; 
  }
}

export default MyOrders;

